<template>
  <v-window-item value="experience">
    <v-card-text>
      <v-card class="bg-white" variant="outlined">
        <v-card-title class="text-subtitle-1">
          <v-icon class="me-1" size="small">mdi-briefcase-outline</v-icon>
          Previous Employment
        </v-card-title>

        <v-card-text>
          <v-form @submit.prevent="submit">
            <v-card
              v-for="(employment, index) in previousEmployments"
              :key="employment.id || index"
              variant="outlined"
              class="mb-4"
            >
              <v-card-title class="text-subtitle-2">
                Employment {{ index + 1 }}
              </v-card-title>
              <v-card-text>
                <v-row>
                  <v-col cols="12" md="6">
                    <v-text-field
                      v-model="employment.company_name"
                      label="Company Name"
                      variant="outlined"
                      bg-color="grey-lighten-4"
                      density="compact"
                      clearable
                    />
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-date-input
                      v-model="employment.date_of_joining"
                      label="Date of Joining"
                      input-format="dd/mm/yyyy"
                      prepend-icon=""
                      prepend-inner-icon="mdi-calendar"
                      variant="outlined"
                      bg-color="grey-lighten-4"
                      density="compact"
                      clearable
                    />
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-date-input
                      v-model="employment.date_of_relieving"
                      label="Date of Relieving"
                      input-format="dd/mm/yyyy"
                      prepend-icon=""
                      prepend-inner-icon="mdi-calendar"
                      variant="outlined"
                      bg-color="grey-lighten-4"
                      density="compact"
                      clearable
                    />
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-select
                      v-model="employment.designation"
                      label="Designation"
                      :items="designationOptions"
                      item-title="text"
                      item-value="value"
                      variant="outlined"
                      bg-color="grey-lighten-4"
                      density="compact"
                      clearable
                    
                        :menu-props="{ contentClass: 'my-custom-dropdown' }"
/>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-text-field
                      v-model="employment.last_drawn_salary"
                      label="Last Drawn Salary"
                      type="number"
                      prefix="৳"
                      variant="outlined"
                      bg-color="grey-lighten-4"
                      density="compact"
                      clearable
                    />
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-select
                      v-model="employment.job_type"
                      label="Job Type"
                      :items="jobTypeOptions"
                      item-title="text"
                      item-value="value"
                      variant="outlined"
                      bg-color="grey-lighten-4"
                      density="compact"
                      clearable
                    
                        :menu-props="{ contentClass: 'my-custom-dropdown' }"
/>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-textarea
                      v-model="employment.company_address"
                      label="Company Address"
                      rows="3"
                      auto-grow
                      variant="outlined"
                      bg-color="grey-lighten-4"
                      density="compact"
                      clearable
                    />
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-textarea
                      v-model="employment.reason_for_leaving"
                      label="Reason For Leaving"
                      rows="3"
                      auto-grow
                      variant="outlined"
                      bg-color="grey-lighten-4"
                      density="compact"
                      clearable
                    />
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-text-field
                      v-model="employment.reporting_to"
                      label="Reporting To"
                      variant="outlined"
                      bg-color="grey-lighten-4"
                      density="compact"
                      clearable
                    />
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-text-field
                      v-model="employment.reporting_officer_contact"
                      label="Reporting Officer Contact No."
                      type="tel"
                      variant="outlined"
                      bg-color="grey-lighten-4"
                      density="compact"
                      clearable
                    />
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-actions class="px-4 pb-4">
                <v-spacer />
                <v-btn
                  color="error"
                  variant="outlined"
                  size="small"
                  type="button"
                  :disabled="previousEmployments.length === 1"
                  @click="removeEmployment(index)"
                >
                  <v-icon start size="small">mdi-delete</v-icon>
                  Remove
                </v-btn>
              </v-card-actions>
            </v-card>

            <v-btn
              color="primary"
              variant="tonal"
              type="button"
              class="mb-3"
              @click="addEmployment"
            >
              <v-icon start>mdi-plus</v-icon>
              Add More
            </v-btn>

            <v-card-actions class="px-0">
              <v-spacer />
              <v-btn color="primary" type="submit" variant="flat" :loading="submitting">
                Update
              </v-btn>
            </v-card-actions>
          </v-form>
        </v-card-text>
      </v-card>
    </v-card-text>
  </v-window-item>
</template>

<script>
import { useStore } from 'vuex';
import { useForm } from 'vee-validate';
import * as yup from 'yup';
import { ref } from 'vue';
import { toast } from 'vue3-toastify';

const createEmployment = () => ({
  id: null,
  company_name: '',
  date_of_joining: '',
  date_of_relieving: '',
  designation: '',
  last_drawn_salary: '',
  company_address: '',
  job_type: '',
  reason_for_leaving: '',
  reporting_to: '',
  reporting_officer_contact: ''
});

export default {
  props: {
    userExperienceInfoData: {
      type: Array,
      default: () => []
    },
    employeeId: {
      type: [String, Number],
      default: null
    }
  },
  data: () => ({
    submitting: false
  }),
  computed: {
    designationOptions() {
      return [
        { text: 'Software Engineer', value: 'software_engineer' },
        { text: 'Senior Software Engineer', value: 'senior_software_engineer' },
        { text: 'Team Lead', value: 'team_lead' },
        { text: 'Project Manager', value: 'project_manager' },
        { text: 'Business Analyst', value: 'business_analyst' },
        { text: 'UI/UX Designer', value: 'ui_ux_designer' },
        { text: 'DevOps Engineer', value: 'devops_engineer' },
        { text: 'Quality Assurance', value: 'quality_assurance' },
        { text: 'Data Analyst', value: 'data_analyst' },
        { text: 'Marketing Manager', value: 'marketing_manager' },
        { text: 'Sales Executive', value: 'sales_executive' },
        { text: 'HR Manager', value: 'hr_manager' },
        { text: 'Accountant', value: 'accountant' },
        { text: 'Administrative Assistant', value: 'administrative_assistant' },
        { text: 'Operations Manager', value: 'operations_manager' },
        { text: 'Other', value: 'other' }
      ];
    },
    jobTypeOptions() {
      return [
        { text: 'Full Time', value: 'full_time' },
        { text: 'Part Time', value: 'part_time' },
        { text: 'Contract', value: 'contract' },
        { text: 'Internship', value: 'internship' },
        { text: 'Freelance', value: 'freelance' },
        { text: 'Consultant', value: 'consultant' }
      ];
    }
  },
  watch: {
    userExperienceInfoData: {
      handler(data) {
        const records = data?.data || data || [];
        this.previousEmployments = records.length
          ? records.map((employment) => ({
            ...createEmployment(),
            id: employment.id,
            employee_id: employment.employee_id,
            company_name: employment.company_name || '',
            date_of_joining: employment.date_of_joining ? new Date(employment.date_of_joining) : '',
            date_of_relieving: employment.date_of_relieving ? new Date(employment.date_of_relieving) : '',
            designation: employment.designation || '',
            last_drawn_salary: employment.last_drawn_salary || '',
            company_address: employment.company_address || '',
            job_type: employment.job_type || '',
            reason_for_leaving: employment.reason_for_leaving || '',
            reporting_to: employment.reporting_to || '',
            reporting_officer_contact: employment.reporting_officer_contact || ''
          })):
          [{ ...createEmployment(), employee_id: this.employeeId }];
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    addEmployment() {
      this.previousEmployments.push(createEmployment());
    },
    removeEmployment(index) {
      if (this.previousEmployments.length > 1) {
        this.previousEmployments.splice(index, 1);
      }
    }
  },
  setup(props) {
    const store = useStore();
    const previousEmployments = ref([]);
    const submitting = ref(false);
    const { handleSubmit } = useForm({
      validationSchema: yup.object({})
    });

    const submit = handleSubmit(async () => {
      submitting.value = true;
      try {
        const employeeId = props.employeeId;
        const employmentData = previousEmployments.value.filter((employment) =>
          employment.company_name || employment.designation || employment.date_of_joining
        );

        const response = await store.dispatch('previousEmploymentInfo/saveEmployeePreviousEmploymentInfo', {
          employeeId,
          employmentData
        });

        toast.success(response?.message , {
          timeout: 3000
        });
      } catch (error) {
        toast.error(error.response?.data?.message);
      } finally {
        submitting.value = false;
      }
    });

    return {
      previousEmployments,
      submitting,
      submit
    };
  }
};
</script>
